import { render, staticRenderFns } from "./m_examination.vue?vue&type=template&id=0ef67c3e&scoped=true"
import script from "./m_examination.vue?vue&type=script&lang=js"
export * from "./m_examination.vue?vue&type=script&lang=js"
import style0 from "./m_examination.vue?vue&type=style&index=0&id=0ef67c3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef67c3e",
  null
  
)

export default component.exports